import React from 'react';
import { Box } from '@material-ui/core';

import { useObservable, ResponsiveContainer } from '@lib/common';
import { propertyQuery } from '@lib/state';
import { PropertyContactList, ContactMap } from 'app/contact/components';

export const ContactPage: React.FC = () => {
  const properties = useObservable(propertyQuery.properties);

  return (
    <>
      <Box marginBottom={2}>
        <ContactMap height={700} properties={properties} />
      </Box>
      <ResponsiveContainer>
        <Box marginY={2}>
          <PropertyContactList properties={properties} />
        </Box>
      </ResponsiveContainer>
    </>
  );
};
